import {ResourceContainer} from './components/resources-container';

export default {
    component: ResourceContainer
};
